import _regeneratorRuntime from "/builds/7ChVgkMg/0/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/builds/7ChVgkMg/0/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.join.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "date-top"
};
var _hoisted_2 = {
  class: "value"
};
var _hoisted_3 = {
  class: "value"
};
var _hoisted_4 = {
  class: "value"
};
import { ref } from "vue";
import { useUserStore } from "@/store/userStore";
import Common from "@/components/dialog/src/Common.vue";
import { updateUserInfo, getUserDetail } from "@/api/user";
import { showToast } from "@/utils/toastUtil";
import dayjs from "dayjs";
import Dialog from "../dialog/dialog";
import { useI18n } from "vue-i18n";
export default {
  __name: 'BirthdayChange',
  props: {
    show: {
      type: Boolean,
      required: false
    },
    trigger: {
      type: String,
      default: ""
    },
    value: {
      type: String,
      default: ""
    }
  },
  emits: ["change"],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var _useI18n = useI18n(),
      t = _useI18n.t;
    var props = __props;
    var emit = __emit;
    var userStore = useUserStore();
    var currentDate = ref([new Date().getFullYear(), new Date().getMonth() + 1, new Date().getDate()]);
    var minDate = new Date(1900, 0, 1);
    var maxDate = new Date(dayjs.tz().startOf("days"));
    var showChooseDate = ref(false);
    function handleSaveBirth() {
      if (props.trigger === "manual") {
        emit("change", currentDate.value.join("-"));
        showChooseDate.value = false;
        return;
      }
      Dialog.confirm({
        title: t("notice"),
        desc: t("notChangeAfterBeingSaved"),
        okText: t("yes"),
        cancelText: t("no"),
        onOk: function onOk() {
          handleConfirm();
        }
      });
    }
    function handleConfirm() {
      return _handleConfirm.apply(this, arguments);
    }
    function _handleConfirm() {
      _handleConfirm = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var birthDay, res, result;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              birthDay = dayjs.tz(currentDate.value.join("-")).startOf("days").valueOf();
              _context.next = 3;
              return updateUserInfo({
                birthday: birthDay === 0 ? 1 : birthDay,
                customer_id: userStore.getUserInfo.customer_id
              });
            case 3:
              res = _context.sent;
              if (!res.isOK) {
                _context.next = 11;
                break;
              }
              showChooseDate.value = false;
              showToast("Successfully");
              _context.next = 9;
              return getUserDetail();
            case 9:
              result = _context.sent;
              if (result.isOK) {
                userStore.setUserInfo(result.data);
              }
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return _handleConfirm.apply(this, arguments);
    }
    return function (_ctx, _cache) {
      var _component_van_date_picker = _resolveComponent("van-date-picker");
      return _openBlock(), _createElementBlock("div", null, [_createElementVNode("span", {
        onClick: _cache[0] || (_cache[0] = function () {
          return showChooseDate.value = true;
        })
      }, _toDisplayString(__props.value || "Select"), 1), _createVNode(Common, {
        visible: showChooseDate.value,
        "onUpdate:visible": _cache[2] || (_cache[2] = function ($event) {
          return showChooseDate.value = $event;
        }),
        "ok-text": 'Save',
        title: "Birthday",
        "show-close-btn": "",
        "without-cancel": "",
        "show-bottom-shadow": "",
        "on-ok": handleSaveBirth
      }, {
        content: _withCtx(function () {
          return [_createVNode(_component_van_date_picker, {
            modelValue: currentDate.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
              return currentDate.value = $event;
            }),
            "show-toolbar": false,
            "min-date": _unref(minDate),
            "max-date": _unref(maxDate)
          }, {
            "columns-top": _withCtx(function () {
              return [_createElementVNode("div", _hoisted_1, [_createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t("year")), 1), _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t("month")), 1), _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t("day")), 1)])];
            }),
            _: 1
          }, 8, ["modelValue", "min-date", "max-date"])];
        }),
        _: 1
      }, 8, ["visible"])]);
    };
  }
};